/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LatestPaymentResponse } from './LatestPaymentResponse';
import {
    LatestPaymentResponseFromJSON,
    LatestPaymentResponseFromJSONTyped,
    LatestPaymentResponseToJSON,
    LatestPaymentResponseToJSONTyped,
} from './LatestPaymentResponse';

/**
 * 
 * @export
 * @interface TerminalWithLatestPaymentResponse
 */
export interface TerminalWithLatestPaymentResponse {
    /**
     * 
     * @type {TerminalWithLatestPaymentResponseLatestStateEnum}
     * @memberof TerminalWithLatestPaymentResponse
     */
    latestState: TerminalWithLatestPaymentResponseLatestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TerminalWithLatestPaymentResponse
     */
    pspTerminalId: string;
    /**
     * 
     * @type {string}
     * @memberof TerminalWithLatestPaymentResponse
     */
    batteryLevel?: string | null;
    /**
     * 
     * @type {LatestPaymentResponse}
     * @memberof TerminalWithLatestPaymentResponse
     */
    latestPayment?: LatestPaymentResponse | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalWithLatestPaymentResponse
     */
    name?: string | null;
}


/**
 * @export
 */
export const TerminalWithLatestPaymentResponseLatestStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type TerminalWithLatestPaymentResponseLatestStateEnum = typeof TerminalWithLatestPaymentResponseLatestStateEnum[keyof typeof TerminalWithLatestPaymentResponseLatestStateEnum];


/**
 * Check if a given object implements the TerminalWithLatestPaymentResponse interface.
 */
export function instanceOfTerminalWithLatestPaymentResponse(value: object): value is TerminalWithLatestPaymentResponse {
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    return true;
}

export function TerminalWithLatestPaymentResponseFromJSON(json: any): TerminalWithLatestPaymentResponse {
    return TerminalWithLatestPaymentResponseFromJSONTyped(json, false);
}

export function TerminalWithLatestPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalWithLatestPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'latestState': json['latestState'],
        'pspTerminalId': json['pspTerminalId'],
        'batteryLevel': json['batteryLevel'] === undefined ? undefined : json['batteryLevel'] === null ? null : json['batteryLevel'],
        'latestPayment': json['latestPayment'] === undefined ? undefined : json['latestPayment'] === null ? null : LatestPaymentResponseFromJSON(json['latestPayment']),
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
    };
}

export function TerminalWithLatestPaymentResponseToJSON(json: any): TerminalWithLatestPaymentResponse {
    return TerminalWithLatestPaymentResponseToJSONTyped(json, false);
}

export function TerminalWithLatestPaymentResponseToJSONTyped(value?: TerminalWithLatestPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latestState': value['latestState'],
        'pspTerminalId': value['pspTerminalId'],
        'batteryLevel': value['batteryLevel'],
        'latestPayment': LatestPaymentResponseToJSON(value['latestPayment']),
        'name': value['name'],
    };
}

